<div class="p-5" aria-busy="true">
  <div
    class="flex justify-content-center flex-wrap h-screen align-items-stretch align-content-center gap-3">
    @for (card of cards; track $index) {
      <div
        class="p-card w-24rem flex align-self-stretch flex-column p-3 gap-5 card"
        [style.animation-delay]="$index * 60 + 'ms'">
        <div class="flex align-items-center gap-2">
          <p-skeleton size="1.25rem" />
          <div class="flex-1">
            <p-skeleton [width]="card.title + '%'" height="1.25rem" />
          </div>
        </div>
        <div class="flex flex-column gap-2">
          @for (line of card.lines; track $index) {
            <p-skeleton [width]="line + '%'" height="0.9rem" />
          }
        </div>
        <footer class="mt-auto flex justify-content-end">
          <p-skeleton width="8rem" height="2.4rem" borderRadius="2rem" />
        </footer>
      </div>
    }
  </div>
</div>
